import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { forwardRef } from 'react';
import styled, { css, ThemeProvider } from 'styled-components';
import { spacingsTemplate, typographyTemplate, bordersTemplate, useToken } from '@equinor/eds-utils';
import { applyVariant, tableCell } from './DataCell.tokens.js';
import { jsx } from 'react/jsx-runtime';
import { useEds } from '../../EdsProvider/eds.context.js';

var _excluded = ["children", "variant"];
var StyledTableCell = styled.td.withConfig({
  displayName: "DataCell__StyledTableCell",
  componentId: "sc-15tuitc-0"
})(function (_ref) {
  var _theme$validation$err;
  var theme = _ref.theme,
    color = _ref.color;
  var height = theme.height,
    typography = theme.typography,
    spacings = theme.spacings,
    border = theme.border,
    align = theme.align;
  var backgroundColor = color === 'error' ? (_theme$validation$err = theme.validation.error) === null || _theme$validation$err === void 0 ? void 0 : _theme$validation$err.background : '';
  var base = css(["min-height:", ";height:", ";background:", ";vertical-align:", ";box-sizing:border-box;", " ", " ", ""], height, height, backgroundColor, align.vertical, spacingsTemplate(spacings), typographyTemplate(typography), bordersTemplate(border));
  return base;
});
var TableDataCell = /*#__PURE__*/forwardRef(function TableDataCell(_ref2, ref) {
  var children = _ref2.children,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'text' : _ref2$variant,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var _useEds = useEds(),
    density = _useEds.density;
  var token = useToken({
    density: density
  }, applyVariant(variant, tableCell));
  return /*#__PURE__*/jsx(ThemeProvider, {
    theme: token,
    children: /*#__PURE__*/jsx(StyledTableCell, _objectSpread(_objectSpread({}, rest), {}, {
      ref: ref,
      children: children
    }))
  });
});

export { TableDataCell };
